import React from 'react'
import {PRIVACY_POLICY_LINK,TERMS_OF_SERVICE_LINK,SUPPORT_LINK,GET_CARDS_LINK} from '../externalLinks'

class FooterPhone extends React.Component{

  render() {   

    return(
		  <div className='footerPhone'>  		    
			    <a className='footerPhone-link' href={GET_CARDS_LINK} target='_blank' >
			      Get Cards
			    </a>
			    <a className='footerPhone-link' href={SUPPORT_LINK} target='_blank' >
			      Support
			    </a>
			    <a className='footerPhone-link' href={TERMS_OF_SERVICE_LINK} target='_blank' >
			      Terms of Service
			    </a>
			    <a className='footerPhone-link' href={PRIVACY_POLICY_LINK} target='_blank' >
			      Privacy Policy
			    </a>	   	    
			    <div className='footerPhone-copyright'>
		    		© Plickers 2018
		    	</div>
			    <a className='footerPhone-supportEmail' href='mailto:hello@plickers.com'>
			      hello@plickers.com
			    </a>
			  
		    
		  </div>
		)
	}
}

export default FooterPhone
